import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import EnvironmentService from 'cio/services/environment';
import { announceHydraNavigate } from '@customerio/hydra-nav-state';

export default class CdpOutRoute extends Route {
  @service features!: FeaturesService;
  @service environment!: EnvironmentService;

  crumb() {
    return {
      name: 'Customer.io Data Pipelines',
      path: 'integrations.cdp_in',
    };
  }

  redirect() {
    if (!this.features.isEnabled('cdp_enabled')) {
      this.router.transitionTo('dashboard');
    } else {
      let destinationOverviewURL = `/workspaces/${this.environment.current.id}/pipelines/destinations/journeys`;
      announceHydraNavigate(destinationOverviewURL, { targetApp: 'pipelines', shouldReplaceHistoryEntry: true });
    }
  }
}
